import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

import type { EstruturaEmailPessoaFisicaRequest, EstruturaEmailPessoaFisicaResponse } from './email-pessoa-fisica.model';

@Injectable({ providedIn: 'root' })
export class EmailPessoaFisicaService extends BaseService {
    readonly PATH = SICOM_PATHS.servicos.pessoaFisica.email;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    consultarEstrutura(params?: EstruturaEmailPessoaFisicaRequest, context?: HttpContext): Observable<EstruturaEmailPessoaFisicaResponse> {
        let httpParams = new HttpParams();

        if (params?.nomeSolicitante) {
            httpParams = httpParams.set('nomeSolicitante', params.nomeSolicitante);
        }

        if (params?.conselhoOrgao) {
            httpParams = httpParams.set('conselhoOrgao', params.conselhoOrgao);
        }

        if (params?.uf) {
            httpParams = httpParams.set('uf', params.uf);
        }

        return this.http.get<EstruturaEmailPessoaFisicaResponse>(`${this.PATH}/estrutura`, { params: httpParams, context });
    }
}
